import { CropGroup, CropZone, Farm, Field } from './types';

// Pure id/label helpers — exported for direct unit testing (no behavior change).
export const getCzArea = (cz: CropZone) =>
  cz.reportedArea || cz.boundaryArea || 0;

export const pluralize = (count: number, singular: string) =>
  count === 1 ? singular : `${singular}s`;

export const getFieldCropZoneIds = (field: Field) =>
  field.cropzones.map(cz => cz.id);

export const getFarmCropZoneIds = (farm: Farm) =>
  farm.fields.flatMap(f => getFieldCropZoneIds(f));

export const collectExpandKeys = (
  farms: Farm[],
  criteria: string,
  farmKeys: string[],
  fieldKeys: string[]
) => {
  farms.forEach(farm => {
    farmKeys.push(farm.id);
    if (farm.name.toLowerCase().includes(criteria)) return;
    farm.fields.forEach(field => {
      if (!field.name.toLowerCase().includes(criteria)) {
        fieldKeys.push(field.id);
      }
    });
  });
};

export const collectExpandKeysCropMode = (
  cg: CropGroup,
  criteria: string,
  farmKeys: string[],
  fieldKeys: string[]
) => {
  farmKeys.push(cg.id);
  cg.farms.forEach(farm => {
    const farmKey = `${cg.id}:${farm.id}`;
    farmKeys.push(farmKey);
    if (farm.name.toLowerCase().includes(criteria)) return;
    farm.fields.forEach(field => {
      if (!field.name.toLowerCase().includes(criteria)) {
        fieldKeys.push(`${farmKey}:${field.id}`);
      }
    });
  });
};

export const getCropGroupCropZoneIds = (cg: CropGroup) =>
  cg.farms.flatMap(farm => getFarmCropZoneIds(farm));
